import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
import moment from 'moment'
let id: any = 0
import AreaApi from '@/api/area'
import { checkCarNo, hasVisitor, debounce } from '@/utils/util'
import { caseNoReg, taskRequest, contactPhonePattern } from '@/utils/regExp'
import isEmpty from 'lodash/isEmpty'
import { nameLength } from '@/config/global'
import SprFestModal from '@/components/Modal/SprFestModal.vue'
import { beforeAddTask } from '@/utils/order'
import VisitorApi from '@/api/visitor'
const MAX_FILE_NUM = 10
const MAX_FILE_SIZEM = 10
const debounceSearch = debounce(300)
const debounceUpload = debounce(100)

@Component({
	components: {
		SprFestModal,
	},
})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public areaName: string = ''
	public areaData: any = ''
	public resurvey: boolean = false
	public taskType: any = ''
	public nameLength: any = nameLength
	public taskRequest: any = taskRequest
	public contactPhonePattern: any = contactPhonePattern
	public caseNoReg: any = caseNoReg
	public uploading = false
	public fileListMap: any = {}
	public fileIdMap: any = {}
	public hasVisitor: any = hasVisitor

	public caseWaring: '' | 'warning' | 'success' | 'error' | 'validating' = ''
	public caseHelpMes = ''

	@Prop()
	public data!: any

	@Prop()
	public riskDisposal!: any

	@Prop()
	public visible!: boolean

	@Prop()
	public parentOrderId!: any

	@Watch('$store.state.setting', { immediate: true })
	private onSettingChange() {
		if (this.$store.state.setting) {
			this.$nextTick(() => {
				// 上传文件初始化
				this.$set(this.fileListMap, this.taskType, [])
				this.$set(this.fileIdMap, this.taskType, [])
			})
		}
	}

	public beforeSubmit(values: any) {
		return values
	}

	public get isRiskDisposal() {
		return !!this.riskDisposal
	}

	public moment(timestamp: any) {
		return moment(timestamp)
	}

	public disabledEffectDate(effectVal: any) {
		return (
			effectVal.format('YYYY-MM-DD') !==
				moment(new Date()).format('YYYY-MM-DD') &&
			effectVal.valueOf() < new Date()
		)
	}

	public prevStep() {
		this.$emit('prevStep')
	}

	public onCheckUrgent(e: Event) {
		const target = e.target as any
		this.addForm.setFieldsValue({
			urgentTask: target.checked ? '1' : '0',
		})
	}

	private getRecent(list: any) {
		let latestIndex = 0
		list.forEach((item: any, key: any) => {
			if (item.endDate > list[latestIndex].endDate) {
				latestIndex = key
			}
		})
		return list[latestIndex]
	}

	public async handleRisk() {
		const res = await TaskApi.getTaskDetail(this.riskDisposal.orderId)
		const order: any = res.data.order
		const injured: any = res.data.injured
		const injuredPhoneArray: any = []
		const injuredPhone: any = []
		const hasWork = injured.work && !['0', ''].includes(injured.work.hasWork)
		let id = 0
		for (const item of injured.selfPhone.split(',')) {
			injuredPhoneArray.push(item)
			injuredPhone.push(id++)
		}
		this.addForm.setFieldsValue({
			caseNo: order.caseNo,
			injuredName: order.injuredName || injured.name,
			injuredPhone,
		})
		if (
			this.taskType === '4' &&
			injured.livingInfoList &&
			injured.livingInfoList.length
		) {
			let recentLive: any = this.getRecent(injured.livingInfoList)

			this.addForm.setFieldsValue({
				code: {
					key: `${recentLive.provinceCode}-${recentLive.cityCode}-${recentLive.areaCode}`,
					label: recentLive.homeAddress,
				},
				address: recentLive.detailAddress,
			})
		} else if (
			this.taskType === '5' &&
			hasWork &&
			injured.work.workInfoList.length
		) {
			let recentWork: any = this.getRecent(injured.work.workInfoList)
			this.addForm.setFieldsValue({
				code: {
					key: `${recentWork.provinceCode}-${recentWork.cityCode}-${recentWork.areaCode}`,
					label: recentWork.workAddress,
				},
				injuredCompany: recentWork.companyName,
				address: recentWork.workPlace,
			})
		}

		this.$nextTick(() => {
			this.addForm.setFieldsValue({
				injuredPhoneArray,
			})
		})
	}

	public created() {
		this.addForm = this.$form.createForm(this)
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.getFieldDecorator('injuredPhone', {
			initialValue: [id],
			preserve: true,
		})
		this.addForm.getFieldDecorator('urgentTask', { preserve: true })
		if (this.riskDisposal) {
			this.handleRisk()
		}

		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
	}

	public checkCaseNo(rule: any, value: any, callback: Function) {
		var reg = /^[^\u4e00-\u9fa5]+$/
		if (!!value && !reg.test(value)) {
			this.caseWaring = 'error'
			this.caseHelpMes = '不能输入中文字符'
			return
		}
		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
		console.log('注: 如非本地承保案件，委派前建议先获取承保机构同意')
		return callback()
	}

	public onHospitalSelect(res: any) {
		this.$nextTick(() => {
			this.addForm.setFieldsValue({
				hospital: {
					label: res.title,
					key: res.point.lng + '-' + res.point.lat,
				},
			})
		})
	}

	public onAreaSelect(res: any) {
		const code = res.code.split('-')
		this.areaData = {
			cityCode: code[1],
			areaCode: code[2],
		}
		this.searchHospital = []
	}

	public onIsInjuredChange(e: any) {
		this.isInjured = e.target.checked

		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredName: this.addForm.getFieldValue('ownerName'),
				injuredPhoneArray,
			})
		}
	}

	public onOwnerNameInput(e: any) {
		if (this.isInjured) {
			this.addForm.setFieldsValue({
				injuredName: e.target.value,
			})
		}
	}

	public onOwnerPhoneInput(e: any) {
		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredPhoneArray,
			})
		}
	}

	public onHasCarNoChange(e: any) {
		this.hasNoCarNo = e.target.checked
		this.addForm.setFieldsValue({
			carNo: e.target.checked ? '无牌' : '',
		})
	}

	public setPublisher() {
		this.$nextTick(() => {
			if (this.sameWithPublisher) {
				this.addForm.setFieldsValue({
					contact: this.$store.state.user.userInfo.name,
					contactPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					contact: undefined,
					contactPhone: undefined,
				})
			}
		})
	}

	public onWithPublisherChange(e: any) {
		this.sameWithPublisher = e.target.checked
		this.setPublisher()
	}

	/*就诊地区输入搜索*/
	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public removePhone(k: any) {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		// We need at least one passenger
		if (injuredPhone.length === 1) {
			return
		}

		// can use data-binding to set
		this.addForm.setFieldsValue({
			injuredPhone: injuredPhone.filter((key: any) => key !== k),
		})
	}

	public addPhone() {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		const nextPhone = injuredPhone.concat(++id)
		// can use data-binding to set
		// important! notify form to detect changes
		this.addForm.setFieldsValue({
			injuredPhone: nextPhone,
		})
	}

	public checkCarNo(rule: string, value: string, cb: any) {
		const carNo = value && value.toUpperCase()
		if (value !== carNo) {
			this.addForm.setFieldsValue({
				carNo,
			})
			this.addForm.validateFields(['carNo'])
		}

		if (!carNo) {
			cb(new Error('请输入标的车牌号'))
		} else if (carNo === '无牌') {
			cb()
		} else if (!checkCarNo(carNo)) {
			cb(new Error('请输入正确的标的车牌号'))
		} else {
			cb()
		}
	}

	public onOk() {
		this.$emit('ok')
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		if (this.riskDisposal && this.riskDisposal.riskDetailId) {
			this.$multiTab.open(
				`/AiiTasks/TasksDetail/${this.riskDisposal.orderId}/${this.riskDisposal.taskType}`
			)
		} else {
			this.$multiTab.open('/AiiTasks/TasksList')
		}
	}

	public uploadFileList(fileList: any, checkedType: number) {
		if (fileList.length + this.fileListMap[checkedType].length > MAX_FILE_NUM) {
			this.$message.error(`上传单证文件个数限制${MAX_FILE_NUM}个`)
			return
		}
		for (let i = 0; i < fileList.length; i++) {
			let currentFile = fileList[i]
			if (currentFile.size > MAX_FILE_SIZEM * 1024 * 1024) {
				this.$message.error(`${currentFile.name}文件大小超过${MAX_FILE_SIZEM}M`)
				return
			}
		}

		this.uploading = true
		const hide: any = this.$message.loading('上传中...', 0)
		let num = 0
		for (const file of fileList) {
			const formData = new FormData()
			formData.append('filecontent', file)
			VisitorApi.uploadFile({ formData })
				.then((res: any) => {
					num++
					this.$set(this.fileListMap, checkedType, [
						...this.fileListMap[checkedType],
						file,
					])
					let fileItem = {
						fileId: res.data.fileId,
						fileName: file.name,
						uid: file.uid,
					}
					this.$set(this.fileIdMap, checkedType, [
						...this.fileIdMap[checkedType],
						fileItem,
					])
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
					}
					// this.$message.success(`${file.name}上传成功`)
				})
				.catch((err: any) => {
					num++
					this.$message.error(`${file.name}上传失败`)
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
					}
				})
		}
	}

	public beforeUpload(file: any, fileList: any, checkedType: number) {
		debounceUpload(() => {
			this.uploadFileList(fileList, checkedType)
		})

		return false
	}

	public handleRemove(file: any, checkedType: number) {
		let index = this.fileListMap[checkedType].indexOf(file)
		this.fileListMap[checkedType].splice(index, 1)
		this.fileIdMap[checkedType].splice(index, 1)
	}
}
